import type { HTMLMotionProps, Variants } from 'framer-motion';
import { motion, useReducedMotion } from 'framer-motion';
import { fadeUp, opacityOnly } from '@/animations/variants';

type RevealElement = 'div' | 'section' | 'article' | 'header' | 'footer' | 'nav';

type RevealProps = HTMLMotionProps<'div'> & {
  as?: RevealElement;
  variants?: Variants;
};

const motionElements = {
  div: motion.div,
  section: motion.section,
  article: motion.article,
  header: motion.header,
  footer: motion.footer,
  nav: motion.nav,
};

export function Reveal({
  as = 'div',
  variants = fadeUp,
  children,
  ...props
}: RevealProps) {
  const reduce = useReducedMotion();
  const Component = motionElements[as];

  return (
    <Component
      variants={reduce ? opacityOnly : variants}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, margin: '-10% 0px' }}
      {...props}
    >
      {children}
    </Component>
  );
}
